import React from 'react';
import CheckBoxGradient from './../../checkbox/checkbox';
import { CtaButton } from './../../cta-button/cta-button';
import { UseFormRegister, FieldErrors, UseFormWatch } from 'react-hook-form';

interface ConcertRegisterFormFooterProps {
    register: UseFormRegister<any>;
    errors?: FieldErrors<any>;
    watch: UseFormWatch<any>;
    termsOfService: string;
    mediaConsent: string;
    isSubmitting?: boolean; // Thêm prop để track submit state
    // Backward compatibility props (optional)
    isAgreed?: boolean;
    handleAgreedCheck?: () => void;
    isAllowMediaConsent?: boolean;
    handleAllowMediaConsentCheck?: () => void;
}

const VuonConcert2025SectionFooter: React.FC<ConcertRegisterFormFooterProps> = ({
    register,
    errors,
    watch,
    mediaConsent,
    termsOfService,
    isSubmitting = false,
    // Backward compatibility
    isAgreed,
    handleAgreedCheck,
    isAllowMediaConsent,
    handleAllowMediaConsentCheck,
}) => {
    // Lấy giá trị hiện tại của checkbox từ form state
    const termsOfServiceValue = watch('termsOfService');
    const mediaConsentValue = watch('mediaConsent');

    return (
        <div className="w-full flex flex-col gap-[18px] max-w-[600px] xl:max-w-[1200px] mx-auto">
            <div>
                <CheckBoxGradient
                    labelClassName="text-[14px] font-bold text-white font-montserrat"
                    id={'terms-of-service-checkbox'}
                    label={termsOfService}
                    value={termsOfServiceValue}
                    isDisabled={true}
                    {...register('termsOfService')}
                />
                {errors?.termsOfService && (
                    <p className="mt-2 text-xs text-red-500">
                        {errors.termsOfService.message as string}
                    </p>
                )}
            </div>

            <div>
                <CheckBoxGradient
                  isDisabled={true}
                    labelClassName="text-[14px] font-bold text-white font-montserrat"
                    id={'median-consent-checkbox'}
                    label={mediaConsent}
                    value={mediaConsentValue}
                    {...register('mediaConsent')}
                />
                {errors?.mediaConsent && (
                    <p className="mt-2 text-xs text-red-500">
                        {errors.mediaConsent.message as string}
                    </p>
                )}
            </div>

            <div className="mx-auto mt-[38px] w-full">
                <CtaButton
                    type="button"
                    text={<p className={'uppercase text-[12px] xs:text-[14px] sm:text-[16px] md:text-[18px]'}>{'ĐÃ ĐÓNG CỔNG ĐĂNG KÝ'}</p>}
                    className="mx-auto w-[60%] min-w-[235px] max-w-[371px] font-kpz_font font-bold"
                    disable={true}
                />
            </div>
        </div>
    );
};

export default VuonConcert2025SectionFooter;
